// Live Event Painting — edit copy, options, and FAQ here.
export const LIVE_PAINTING = {
  title: "Live Event Painting",
  hero: {
    headline: "Your event,",
    headlineItalic: "painted as it happens.",
    sub:
      "Joseph sets up an easel in the room and paints the evening live — the ceremony, the first dance, the opening-night crowd, the keynote moment. Guests watch the canvas come to life. You keep the finished painting.",
  },
  facts: [
    { k: "Events", v: "Weddings · gallery openings · corporate · private parties" },
    { k: "Length", v: "3–5 hours on-site (longer by arrangement)" },
    { k: "Canvas", v: "24×30 to 36×48 — finished and delivered within 2–3 weeks" },
    { k: "Travel", v: "Denver metro included · Colorado & regional by quote" },
    { k: "Booking", v: "Quoted per event · 25% deposit holds your date" },
  ],
  how: [
    { n: "01", title: "Tell us about the event", body: "Date, venue, the moment you want captured, and roughly how many guests. Joseph replies within two business days with a quote." },
    { n: "02", title: "Hold the date", body: "A 25% deposit secures the evening. We'll confirm arrival time, setup footprint (about 6×6 ft), and lighting with your planner or venue." },
    { n: "03", title: "Painting, live", body: "Joseph arrives 1–2 hours early to block in the room, then paints the key moment as it unfolds. Guests are welcome to watch and ask questions." },
    { n: "04", title: "The finished work", body: "Final details, varnish, and signing happen back in the studio. Your painting is delivered ready to hang in 2–3 weeks." },
  ],
  included: [
    "Professional artist on-site for the full booked window",
    "Gallery-wrapped canvas, paints, easel, and drop cloth — we bring everything",
    "Studio finishing, varnish, and signature on the back",
    "Delivery or pickup in the Denver metro",
    "Optional signed prints of the finished painting for the wedding party or team",
  ],
  faq: [
    { q: "How far in advance should we book?", a: "Weddings and corporate events typically book 2–6 months out. Saturdays in May–October go first. Short-notice dates are sometimes possible — ask." },
    { q: "Do you need anything from the venue?", a: "A roughly 6×6 ft footprint with a clear sightline to the moment being painted, decent light, and access to a standard outlet if the event runs into the evening." },
    { q: "Can guests be in the painting?", a: "Yes. Most couples ask for the first dance or ceremony with the crowd. For corporate events, the keynote, the ribbon-cutting, or the room itself." },
    { q: "What does it cost?", a: "Every event is quoted on length, canvas size, and travel. Send the form below and you'll have a number within two business days — no obligation." },
    { q: "Do you also do live iPad drawings?", a: "Yes — quick digital portraits for activations and pop-ups. Mention it in the notes and we'll quote both." },
  ],
  form: {
    eventTypes: [
      { id: "wedding", label: "Wedding" },
      { id: "gallery-opening", label: "Gallery opening / art event" },
      { id: "corporate", label: "Corporate event / activation" },
      { id: "private", label: "Private party / celebration" },
      { id: "festival", label: "Festival / public event" },
      { id: "other", label: "Other" },
    ],
    durations: ["3 hours", "4 hours", "5 hours", "Full day", "Not sure yet"],
    canvasSizes: ["24×30", "30×40", "36×48", "Not sure — recommend one"],
  },
  photo: {
    src: "https://customer-assets-jai6qajn.emergentagent.net/job_black-western-studio/artifacts/fc3720b8ba1dbfac_IMG_3692.JPG",
    alt: "Joseph Graves Jr. painting live on the Dearfield mural at Jackson Lake State Park as Governor Jared Polis looks on",
    caption: "Painting live · Dearfield mural unveiling with Gov. Jared Polis · Jackson Lake State Park",
  },
};
